/**
 * Derive a Firebase Storage download URL for a different width using the same token.
 * Returns null if the input is not a Firebase Storage download URL.
 */
export function deriveFirebaseImageUrlForWidth(
  knownDerivativeUrl: string,
  targetWidth: number,
  targetExt: 'webp' | 'jpg' | 'png' = 'webp'
): string | null {
  try {
    const url = new URL(knownDerivativeUrl);
    if (!/firebasestorage\.googleapis\.com$/.test(url.hostname)) return null;

    const segments = url.pathname.split('/').filter(Boolean);
    const bIndex = segments.indexOf('b');
    const oIndex = segments.indexOf('o');
    if (bIndex === -1 || oIndex === -1 || oIndex + 1 >= segments.length) return null;

    const bucket = segments[bIndex + 1];
    const encodedPath = segments[oIndex + 1];
    const token = url.searchParams.get('token');
    if (!bucket || !encodedPath || !token) return null;

    const objectPath = decodeURIComponent(encodedPath);
    const lastSlash = objectPath.lastIndexOf('/');
    const dir = objectPath.substring(0, lastSlash);
    const file = objectPath.substring(lastSlash + 1);

    const dot = file.lastIndexOf('.');
    const base = dot === -1 ? file : file.substring(0, dot);

    const baseWithoutWidth = base.replace(/__w\d+$/, '');
    const targetFile = `${baseWithoutWidth}__w${targetWidth}.${targetExt}`;
    const targetPath = `${dir}/${targetFile}`;
    const targetEncodedPath = encodeURIComponent(targetPath);

    const derived = new URL(`https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${targetEncodedPath}`);
    derived.searchParams.set('alt', 'media');
    derived.searchParams.set('token', token);
    return derived.toString();
  } catch {
    return null;
  }
}



